// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_1EaTd2"};